var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard",class:[{'editor-wrapper': _vm.$route.meta.editor}, {'unpin-layout': (_vm.unpin && _vm.$route.meta.editor)}]},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }